import { useTrans } from "@/utils/useTrans";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/v2-components/ui/accordion";
import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";
import ComponentErrorBoundary from "@/v2-components/pages/ComponentErrorBoundary";

const VRP_FAQ_KEYS = [
  { qKey: "vrp_faq_q_1", aKey: "vrp_faq_a_1" },
  { qKey: "vrp_faq_q_2", aKey: "vrp_faq_a_2" },
  { qKey: "vrp_faq_q_3", aKey: "vrp_faq_a_3" },
  { qKey: "vrp_faq_q_4", aKey: "vrp_faq_a_4" },
] as const;

export const VrpFaqSection = () => {
  const { t } = useTrans(["software"]);
  return (
    <ComponentErrorBoundary>
      <section className="bg-white py-12 laptop:py-16">
        <div className="mx-auto w-full max-w-[1440px] px-4 laptop:px-5">
          <h2 className="w-full pb-5 text-center text-3xl font-400 laptop:pb-8 laptop:text-left laptop:text-5xl">
            FAQ
          </h2>
          <div className="w-full pb-5">
            <Accordion type="single" collapsible>
              {VRP_FAQ_KEYS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-none"
                >
                  <AccordionTrigger
                    size="lg"
                    className="items-start border-coolgray-20 px-0 data-[state=open]:border-b"
                  >
                    <span className="text-left font-500 laptop:text-lg">
                      {t(item.qKey)}
                    </span>
                    <ChevronDownIcon className="size-6 shrink-0" />
                  </AccordionTrigger>
                  <AccordionContent className="px-0 text-base font-400">
                    {t(item.aKey)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </ComponentErrorBoundary>
  );
};
